<template>
    <div>
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
      <!-- <div class="row justify-content-center"> -->
      <div class="row">
        <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5>Sale Commission</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <div class="form-inline ml-auto">
                    <div class="button-group">
                      <!-- <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                      <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="setJournal">Set Journal</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="approveAll">Approve</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="deleteAll">Delete</a></li>
                      </ul> -->
                      <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addSales">
                          <i class="fa fa-plus" aria-hidden="true"></i> New
                      </button>
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                    </div>
                    <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Company:</span>
                        <div class="dropdown-divider"></div>
                        <li v-for="c in companyList" :key="c.id">
                          <a href="#" class="small" tabIndex="-1">
                            <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                          </a>
                        </li>
                      </ul>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ filterData.length }}</b>
                      </span>
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                  </div>
                  <table class="table table-item mb-0 table-sm table-striped">
                      <thead>
                          <tr>
                              <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                  <span v-if="t.name === 'Payment'" class="text-right">
                                  {{ t.name }}
                                  <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>

                                  <span v-else>
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-if="filterData.length < 1">
                          <td colspan="21" style="text-align: center;"><i>No Data</i></td>
                        </tr>
                        <tr v-for="u in filterData" :key="u.id">
                            <td @click="editData(u.id)"><b style="cursor: pointer;">{{ u.name }}</b></td>
                            <td>
                              <span class="badge badge-primary" v-if="u.type === 'salesman'">{{ u.type }}</span>
                              <span class="badge badge-success" v-else-if="u.type === 'customer'">{{ u.type }}</span>
                              <span class="badge badge-info" v-else-if="u.type === 'omzet'">{{ u.type }}</span>
                              <span class="badge badge-secondary" v-else>{{ u.type }}</span>
                            </td>
                            <td class="text-right">{{ u.amount }}</td>
                            <td class="text-right">{{ u.percentage }}</td>
                            <td>{{ u.age }}</td>
                            <td>{{ u.age_limit }}</td>
                            <td>{{ u.company_no }}</td>
                            <td>
                              <span v-if="u.active"><i class="fa fa-check" style="color: green;"></i></span>
                            </td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { saleCommissionUrl, getHeader } from '../../config'

export default {
  name: 'SaleCommissionList',
  components: {
    Loading
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      filterRetur: null,
      filterCompany: ['C0001', 'C0002'],
      loadingSales: true,
      filterStatus: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      checkFilter: [],
      title: [{
        name: 'Name',
        prop: 'name',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Amount',
        prop: 'amount',
        align: 'text-right'
      }, {
        name: 'Percentage',
        prop: 'percentage',
        align: 'text-right'
      }, {
        name: 'Age',
        prop: 'age',
        align: 'text-left'
      }, {
        name: 'Age Limit',
        prop: 'age_limit',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company_no',
        align: 'text-left'
      }, {
        name: 'Active',
        prop: 'active',
        align: 'text-left'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterStatus.length > 0) {
          for (let i = 0; i < this.filterStatus.length; i++) {
            if (d.status === this.filterStatus[i]) {
              return d
            } else if (this.filterStatus[i] === 'outstanding') {
              if (d.total_payment < d.total) {
                return d
              }
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterRetur === true) {
          if (parseFloat(d.return_total) > 0) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      // this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editData (id) {
      axios.get(saleCommissionUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.$emit('editSales', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!!', error.response.data.message, 'error')
          throw error
        })
    },
    addSales () {
      this.$emit('newSales', true)
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var url = saleCommissionUrl
      console.log(url)
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
